var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('v-data-table', _vm._b({
    attrs: {
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.purchaseNo",
      fn: function fn(_ref) {
        var _item$order;

        var item = _ref.item;
        return [_vm._v(_vm._s(item.purchaseNo || (item === null || item === void 0 ? void 0 : (_item$order = item.order) === null || _item$order === void 0 ? void 0 : _item$order.orderNo)))];
      }
    }, {
      key: "item.product",
      fn: function fn(_ref2) {
        var _item$product;

        var item = _ref2.item;
        return [_c('div', {
          staticClass: "d-flex align-center text-left"
        }, [_c('div', [_c('v-img', {
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb,
            "width": "96",
            "height": "96",
            "contain": ""
          }
        })], 1), _c('div', {
          staticStyle: {
            "width": "calc(100% - 96px)"
          }
        }, [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_c('b', {
          staticClass: "text-truncate",
          domProps: {
            "innerHTML": _vm._s(item.product.name)
          }
        })]), _c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_vm._v(_vm._s(item.product.salePrice.format()) + "원")])])])];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref3) {
        var _item$purchase;

        var item = _ref3.item;
        return _c('span', {}, [_vm._v(_vm._s(item.status || ((_item$purchase = item.purchase) === null || _item$purchase === void 0 ? void 0 : _item$purchase.status)))]);
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }, {
      key: "item.resend",
      fn: function fn(_ref5) {
        var _item$issue, _item$issue$pins;

        var item = _ref5.item;
        return _c('span', {}, [(_item$issue = item.issue) !== null && _item$issue !== void 0 && (_item$issue$pins = _item$issue.pins) !== null && _item$issue$pins !== void 0 && _item$issue$pins.length ? _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.resend(item);
            }
          }
        }, [_vm._v("mdi-message")]) : _vm._e()], 1);
      }
    }, {
      key: "item.shippingInfo",
      fn: function fn(_ref6) {
        var _vm$couriers$find;

        var item = _ref6.item;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(item.shippingInfo.method))]), _c('div', [_vm._v(_vm._s(item.shippingInfo.invoiceNumber))]), _c('div', [_vm._v(_vm._s((_vm$couriers$find = _vm.couriers.find(function (courier) {
          return courier.value == item.shippingInfo.courier;
        })) === null || _vm$couriers$find === void 0 ? void 0 : _vm$couriers$find.text))])]);
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return _c('div', {});
      }
    }])
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1), _c('div', {
    staticClass: "mt-30px mt-md-40px"
  }, [_c('v-pagination', _vm._b({
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  }, 'v-pagination', {
    value: _vm.page,
    length: _vm.pageCount,
    'total-visible': 11
  }, false))], 1), _c('claim-dialog', {
    ref: "claimDialog",
    on: {
      "claim": _vm.search
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }